import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { getFeatureFlagsForEvent, updateFeatureFlag } from './services';

export const featureFlagsQueryOptions = shortcode => ({
  queryKey: ['managemobi', 'events', shortcode, 'feature-flags'],
  queryFn: () => getFeatureFlagsForEvent(shortcode),
  staleTime: 1000 * 10,
});

export const useFeatureFlagsQuery = shortcode => useQuery(featureFlagsQueryOptions(shortcode));

export const useUpdateFeatureFlagMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ shortcode, flagId, enabled }) => updateFeatureFlag(shortcode, flagId, enabled),
    onSuccess: (_, { shortcode, flagId, enabled }) => {
      queryClient.setQueryData(featureFlagsQueryOptions(shortcode).queryKey, data =>
        data.map(flag => {
          if (flag.id === flagId) {
            return { ...flag, enabled };
          }
          return flag;
        }),
      );
    },
  });
};
